export const SCROLL_TIMEOUT = 500;
export const MIN_THUMB_SIZE = 16;